import {
  Button,
  Content,
  Flex,
  fromTheme,
  Heading,
  IconButton,
  StrokeIcon,
} from '@acsbe/ui';
import styled from 'styled-components';
import { useDomainSelection, useMerchantSession } from '../../context';
import { CMS, CMS_RATING_URL } from '../../utils/constants';

export const PositivePath = () => {
  const { merchantDetails } = useMerchantSession();
  const { postFeedback } = useDomainSelection();

  const handleClick = () => {
    let ratingUrl: string | undefined;
    if (merchantDetails) {
      if (merchantDetails.source === CMS.LIGHTSPEED) {
        ratingUrl = (CMS_RATING_URL[CMS.LIGHTSPEED] as Function)(
          merchantDetails?.storeId,
        );
      } else {
        ratingUrl = CMS_RATING_URL[merchantDetails.source] as
          | string
          | undefined;
      }
    }

    if (ratingUrl) {
      window.open(ratingUrl, '_blank');
      postFeedback();
    } else {
      console.error(
        'Rating URL not configured for CMS:',
        merchantDetails?.source,
      );
      postFeedback(); // Still submit feedback even if URL is missing
    }
  };

  return (
    <Flex
      align="center"
      scale="ghost"
      paddingBlockStart={10}
      width="456px"
      paddingBlockEnd={8}
      paddingInline={8}
      gap={8}
    >
      <StyledIconButton
        as="div"
        padding={6}
        aria-label="Thumbs Up"
        radius="round"
        scale="success"
      >
        <StrokeIcon name="ThumbsUp" size={32} />
      </StyledIconButton>
      <Flex align="center" gap={4} self="stretch">
        <Heading
          level={3}
          align="center"
          scale="base"
          emphasis="high"
          lineHeight={1.25}
        >
          Great!
        </Heading>
        <Content
          align="center"
          scale="alternative"
          emphasis="none"
          size="xl"
          lineHeight={1.5}
        >
          Share your experience on the {merchantDetails?.source} marketplace.{' '}
          Your review helps others take the first step.
        </Content>
      </Flex>
      <Button
        scale="primary"
        size="lg"
        data-mixpanel="positive-feedback-rate-us"
        fullWidth
        onClick={handleClick}
      >
        <StrokeIcon name="SquareUpRightStroke"></StrokeIcon>
        <span>Rate us</span>
      </Button>
    </Flex>
  );
};

const StyledIconButton = styled(IconButton)`
  cursor: default;
  --fill: ${fromTheme('palette.scales.success.background.static')};
  --text: ${fromTheme('palette.scales.success.text.static')};
  &:hover,
  &:active,
  &:focus,
  &:focus-visible {
    --fill: ${fromTheme('palette.scales.success.background.static')};
    --text: ${fromTheme('palette.scales.success.text.static')};
  }
`;
